<div class="notification-icon">
    <img src="shared-assets/images/general_icons/notification_bell_light.svg" alt="notification">
    <div class="notify-change" *ngIf="newCount !== 0"></div>
</div>
